module.exports = __webpack_public_path__ + "img/Scrapers-min.8444d044.png";